import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { TrainingVersionDto } from '@api/models/training/TrainingVersionDto';
import { trainingVersionService } from '@api/services/services';

type State = BaseType<TrainingVersionDto>;

const initialState: State = {
  state: FetchState.None,
  data: {
    id: '',
    languageVariants: [],
    training: { id: '', name: '' },
    validFrom: '',
    validTo: '',
    duration: 0,
    editable: true,
    first: false,
  },
};

export const trainingVersionSlice = baseSlice({
  name: 'trainingVersion',
  initialState,
});

export const selectTrainingVersionState = (state: RootState) => state.trainingVersion.state;
export const selectTrainingVersion = (state: RootState) => state.trainingVersion.data;
export const selectTrainingVersionLanguages = (state: RootState) => state.trainingVersion.data.languageVariants;

export const trainingVersionActions = trainingVersionSlice.actions;

export const getTrainingVersion = (trainingVersionId: string) => (dispatch: AppDispatch) => {
  const handleGetData = async () => {
    return trainingVersionService.getById(trainingVersionId);
  };

  getItem({
    dispatch,
    actions: trainingVersionActions,
    getData: handleGetData,
  });
};
